import "components/reviews/work-together.css";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import { loadEligibility, ReviewService } from "components/reviews/PartnerReview";
import { InlineLeadReview } from "components/reviews/InlineLeadReview";

export function WorkTogether({ receiverId, name, onPublished }: { receiverId: string; name: string; onPublished: () => void }) {
  const token = useSelector((state: { Login: { token?: string } }) => state.Login.token) || "";
  let viewer: { userId?: number; userType?: string } = {};
  try { viewer = jwtDecode(token); } catch {}
  const canView = !!token && ["contractor", "homeowner"].includes(viewer.userType || "") && String(viewer.userId) !== receiverId;
  const [services, setServices] = useState<ReviewService[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    let active = true;
    setServices([]); setError(""); setDenied(false); setLoading(true);
    if (!canView) { setLoading(false); return; }
    loadEligibility(token).then(result => {
      if (active) setServices(result.services.filter(item => String(item.receiver_id) === receiverId));
    }).catch(failure => {
      if (!active) return;
      const status = (failure as { response?: { status?: number } }).response?.status;
      if (status === 401 || status === 403) setDenied(true);
      else setError("Your shared work couldn’t be loaded.");
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [token, receiverId, canView, attempt]);
  if (!canView || denied || (!loading && !error && !services.length)) return null;
  return <section className="partner-work-together" aria-labelledby="partner-work-title">
    <header><div><h2 id="partner-work-title">Your work together</h2><p>Visible only to you · Linked leads and contracts share one review per participant.</p></div></header>
    {loading && <p role="status" className="partner-work-state">Loading shared work…</p>}
    {error && <div role="alert" className="partner-work-state"><p>{error}</p><button type="button" onClick={() => setAttempt(value => value + 1)}>Try again</button></div>}
    {services.map(service => <article key={`${service.source_type}-${service.project_id}-${service.receiver_id}`} className="partner-work-record">
      <div className="partner-work-record-heading"><div><span>{service.source_type === "contract" ? "Contract" : "Lead"}</span><h3>{service.project_name || (service.source_type === "contract" ? "Contract" : "Lead")}</h3></div><span className="partner-work-status">{service.source_type === "contract" ? "Live" : "Accepted"}</span></div>
      <InlineLeadReview receiverId={service.receiver_id} sourceId={service.project_id} sourceType={service.source_type} name={name} initialService={service} onPublished={() => { setAttempt(value => value + 1); onPublished(); }} />
    </article>)}
  </section>;
}
